import { createSelector } from '@ngrx/store';
import { LoyaltyProgram } from '@rd/types';
import {
  getTransferConnectState,
  TransferConnectV2State,
} from '../reducers/index';
import { LoyaltyProgramState } from '../reducers/loyalty-program.reducer';

const getLoyaltyProgramState = createSelector(
  getTransferConnectState,
  (state: TransferConnectV2State) => state.loyaltyProgram,
);

const getFilterCategory = (state: LoyaltyProgramState) => state.filter.category;
const getFilterKeyword = (state: LoyaltyProgramState) => state.filter.keyword;
const getIndexError = (state: LoyaltyProgramState) => state.index.error;
const getIndexLoading = (state: LoyaltyProgramState) => state.index.loading;
const getShowError = (state: LoyaltyProgramState) => state.show.error;
const getShowLoading = (state: LoyaltyProgramState) => state.show.loading;
const getLoyaltyPrograms = (state: LoyaltyProgramState) =>
  state.loyaltyPrograms;

export const getLoyaltyProgramLoyaltyPrograms = createSelector(
  getLoyaltyProgramState,
  getLoyaltyPrograms,
);

export const getSingleLoyaltyProgramError = createSelector(
  getLoyaltyProgramState,
  getShowError,
);

export const getSingleLoyaltyProgramLoading = createSelector(
  getLoyaltyProgramState,
  getShowLoading,
);

export const getSingleLoyaltyProgram = createSelector(
  // @ts-ignore
  getLoyaltyProgramLoyaltyPrograms,
  (
    loyaltyPrograms: Record<string, LoyaltyProgram>,
    props: { id: string },
  ): LoyaltyProgram => {
    return loyaltyPrograms[props.id] || null;
  },
);

export const getLoyaltyProgramIndexError = createSelector(
  getLoyaltyProgramState,
  getIndexError,
);

export const getLoyaltyProgramIndexLoading = createSelector(
  getLoyaltyProgramState,
  getIndexLoading,
);

export const getLoyaltyProgramFilterCategory = createSelector(
  getLoyaltyProgramState,
  getFilterCategory,
);

export const getLoyaltyProgramFilterKeyword = createSelector(
  getLoyaltyProgramState,
  getFilterKeyword,
);
